export default __webpack_public_path__ + "static/media/icon_express.903ab5d6.png";